import html2pdf from "html2pdf.js";
import moment from "moment";
import React from "react";
import employeeLogo from "../../images/employee.png";

const InvoicePrintThermal = React.forwardRef(
  ({ state, ledger = "" }, printRef) => {
    const baseUrl = localStorage.getItem("base_url");
    const imgSrc = baseUrl ? baseUrl : employeeLogo;
    const company = localStorage.getItem("company");
    const address = localStorage.getItem("address");
    const phone = localStorage.getItem("phone");
    const user = localStorage.getItem("username") || localStorage.getItem("token");
    const phone1 = localStorage.getItem("p1");
    const phone2 = localStorage.getItem("p2");
    const street = localStorage.getItem("street");

    let terms = localStorage.getItem("terms") || "";
    terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

    const rows = state.items.map((item, i) => (
      <tr key={i}>
        {/* <td style={{ padding: "5px", textAlign: "center" }}>{i + 1}</td> */}
        <td style={{ padding: "5px", textAlign: "center" }}>{item?.name}</td>
        <td style={{ padding: "5px", textAlign: "center" }}>
          {item?.saleQuantity || 0}
        </td>
        <td style={{ padding: "5px", textAlign: "center" }}>
          {item?.price % 1 === 0 ? item?.price || 0 : item?.price.toFixed(3)}
        </td>
        <td style={{ padding: "5px", textAlign: "center" }}>
          {item.saleQuantity
            ? item.saleQuantity * parseInt(item.price)
            : item.price || 0}
        </td>
      </tr>
    ));

    return (
      <div
        ref={printRef}
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "12px",
          width: "300px",
          margin: "auto",
          backgroundColor: "white",
          padding: "10px",
          border: "1px solid #ccc",
        }}
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: "300px",
            margin: "0 auto",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {imgSrc && (
            <img
              src={imgSrc}
              style={{ width: "100px", height: "100px" }}
              alt="Company Logo"
            />
          )}
          <h2
            style={{ fontSize: "16px", fontWeight: "bold", margin: "10px 0" }}
          >
            {company || ""}
          </h2>
          <p style={{ margin: "0", fontSize: "12px" }}>
            {street || ""}, {address || ""}
          </p>
          <p style={{ margin: "0", fontSize: "12px" }}>
            Phone:{" "}
            {phone1 || phone2
              ? `${phone1 || ""}${phone2 ? `, ${phone2}` : ""}`
              : phone || ""}
          </p>
          <p style={{ margin: "10px 0", fontSize: "12px" }}>
            Invoice #: {state?.invoiceNumber || ""}
          </p>
          <p style={{ margin: "0", fontSize: "12px" }}>
            Date:{" "}
            {moment(state?.invoiceDate, "DD-MM-YYYY").format("DD-MM-YYYY")}
          </p>

          <table
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0", fontSize: "12px" }}>
                <th style={{ border: "1px solid #000", padding: "5px" }}>
                  Item
                </th>
                <th style={{ border: "1px solid #000", padding: "5px" }}>
                  Qty
                </th>
                <th style={{ border: "1px solid #000", padding: "5px" }}>
                  Rate
                </th>
                <th style={{ border: "1px solid #000", padding: "5px" }}>
                  Total
                </th>
              </tr>
            </thead>
            <tbody style={{ border: "2px solid black" }}>{rows}</tbody>
          </table>

          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              Net Total: {parseFloat(state?.total || 0).toFixed(3)}
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              Received: {parseFloat(state?.recieved || 0).toFixed(3)}
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              Remaining:{" "}
              {parseFloat(state?.total - state?.recieved || 0).toFixed(3)}
            </p>
          </div>

          <p
            style={{ marginTop: "20px", fontSize: "12px", textAlign: "center" }}
          >
            {terms}
          </p>

          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <span
              style={{
                borderTop: "1px solid #000",
                display: "inline-block",
                paddingTop: "5px",
              }}
            >
              Authorized Signature
            </span>
          </div>
        </div>    
      </div>
    );
  }
);

export default InvoicePrintThermal;
